<template>
    <div class="body">
        <!--        聊天框-->
        <div class="body_left" :style="{ height: `calc( ${initData.mainHeight}px - 50px )` }">
            <div :class="!initData.noticeMode ? 'visibilityhidden' : ''" class="notice" @mouseenter="onStop"
                @mouseleave="onStart" @touchstart="onStop" @touchend="onStart">
                <span class="icon">NEWS</span>
                <span  class="icon2"></span>
                <div ref="notice" v-text="noticeText"></div>
            </div>
            <Chatpc></Chatpc>
            <quicklty></quicklty>
            <Footer></Footer>
        </div>
        <Modal v-if="this.$store.getters.getConfigPc.showModal"></Modal>
        <!--        侧边栏-->
        <!-- <Side></Side> -->
    </div>
</template>

<script>
import Footer from "./footer";
import Side from "./side";
import Chatpc from "./chatpc";
import Modal from "./modal";
import quicklty from "./quicklty";

export default {
    name: "bodypc",
    data() {
        return {
            showModal: false,
            noticeText: '',
        }
    },
    mounted() {


    },
    created() {

    },
    watch: {
        initData() {
            if (this.$store.state.initData.noticeMode && this.$store.state.initData.noticeMsg) {
                const div = document.createElement('div')
                div.innerHTML = this.$store.state.initData.noticeMsg
                this.noticeText = div.textContent || div.innerText;
                setTimeout(() => {
                    let time = parseInt(this.noticeText.length / 5).toFixed(0) || 30
                    if (time < 10) time = 30
                    if (!!this.$refs) {
                        this.$refs.notice.style.animationDuration = ` ${time}s `;
                    }
                }, 20)
            }
            return this.$store.state.initData
        },
    },
    computed: {
        initData() {

            return this.$store.state.initData
        },
    },
    methods: {
        onStop() {
            if (!!this.$refs) {
                this.$refs.notice.style.animationPlayState = 'paused';
            }
        },
        onStart() {
            if (!!this.$refs) {
                this.$refs.notice.style.animationPlayState = 'running';
            }
        },
    },
    components: {
        Footer,
        Chatpc,
        Side,
        Modal,
        quicklty
    }
}
</script>

<style scoped>
.body {
    flex: 1;
    display: flex;
    box-shadow: 0px 0px 3px #dcdcdc;
}

.body_left {
    flex: 1;
    width: 1080px;
    position: relative;
    background: white;
    overflow: hidden;
}

.notice {
    padding: 6px 0 6px;
    background: #EAF9FF;
    text-align: left;
    color: #563c3c;
    font-size: 13px;
    width: 100%;
    position: relative;
    line-height: 15px;
    overflow: hidden;
    border-left: 13px solid #EAF9FF;
}

.notice .icon {
    display: inline-block;
    background-color: #C7B160;
    width: 46px;
    height: 16px;
    vertical-align: middle;
    text-align: center;
    color: #fff;
    background-size: 100% 100%;
    /* background-image: url("../../../static/image/notice.png"); */
    position: relative;
    z-index: 9;
    font-size: 12px;
    line-height: 16px;
}
.icon2{
    display: inline-block;
    background: #EAF9FF;
    width: 2px;
    height: 16px;
    vertical-align: middle;
    text-align: center;
    color: #fff;
    background-size: 100% 100%;
    position: relative;
    z-index: 9;
    font-size: 12px;
    line-height: 16px;
    margin-left: -4px;
    border-left: 13px solid #EAF9FF;
}
.notice>div {
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
    width: auto;
    position: absolute;
    animation: 18s move linear infinite normal;
}

@keyframes move {
    0% {
        transform: translateX(600px);
        -webkit-transform: translateX(600px);
    }

    100% {
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
    }
}

.notice p {
    margin: 2px;
}

.visibilityhidden {
    visibility: hidden;

}
</style>



// WEBPACK FOOTER //
// src/components/pc/body.vue